import { API } from "aws-amplify";
import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import IconConfig from "../configs/IconConfig"
import 'react-vertical-timeline-component/style.min.css';
import "./Timeline.css";
import "./VerticalTimeline.css";

import Parser from 'html-react-parser';

export default class Timeline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      events: [],
      username: props.match.params.username
    };
  }

  async componentDidMount() {
    try {
      // Get the events from the database
      const events = await this.getEvents(this.state['username']);

      // Set the events in the state
      this.setState({ events });
    } catch (e) {
      // console.log(JSON.stringify(e));
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  getEvents(username) {
    return API.get("events", "/events/users/" + username);
  }

  renderEventsTimeline(events) {
    return events.length < 1 ?
      <div></div> :
      <VerticalTimeline>
        {
          events.map((event, i) => {
            return this.renderEvent(event, i);
          })
        }
      </VerticalTimeline>
  }

  renderEventsHeader(events) {
    return events.length < 1 ?
      <PageHeader>No timeline found for {this.state.username}</PageHeader> :
      <PageHeader>{this.state.username}'s Timeline</PageHeader>
  }

  selectIcon(currentIcon) {

    if(currentIcon === undefined || currentIcon === null) {
      return <div></div>
    }

    // Look up icon in icon config
    const IconElement = IconConfig.Icons.find(function(icon) {
      return icon.Name === currentIcon;
    });

    // Return if no such icon exists
    if(IconElement === undefined || IconElement === null) {
      return <div></div>
    }

    return <IconElement.Icon />
  }

  formatEventDate(event) {
    if(event.EventEndDate === undefined || event.EventEndDate === null) {
      return event.EventDate;
    } else {
      return `${event.EventDate} - ${event.EventEndDate}`;
    }
  }

  renderEvent(event, i) {
    return <VerticalTimelineElement
          className="vertical-timeline-element"
          date={this.formatEventDate(event)}
          iconStyle={{ background: event.Color, color: '#fff' }}
          icon={this.selectIcon(event.Icon)}
          key={event.EventID}
        >
          <h3 className="vertical-timeline-element-title">{event.Title}</h3>
          <h3 className="vertical-timeline-element-title">{event.SubTitle}</h3>
          <h4 className="vertical-timeline-element-subtitle">{event.EventLocation}</h4>
          <div className="timeline-content" style={{wordWrap: "break-word", whiteSpace: "pre-line"}}>
            {this.renderContent(event)}
          </div>
    </VerticalTimelineElement>
  }

  renderContent(event) {
    if(event.Content === undefined || event.Content === null) {
      return "";
    } else {

      // Wrap iframes in a dynamic container
      var content = this.wrapIframeContent(event.Content);

      // Parse the string content into react component(s)
      return Parser(content);
    }
  }

  wrapIframeContent(content) {
    var regex = /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g;

    var matches = content.match(regex);
    if(matches !== null && matches.length > 0) {
      for(var i = 0; i < matches.length; i++) {
        var match = matches[i];
        content = content.replace(match, `<div class="video-container">${match}</div>`);
      }
    }

    return content;
  }

  renderTimeline() {
    return (
      <div>
        {!this.state.isLoading && this.renderEventsHeader(this.state.events)}
        {!this.state.isLoading && this.renderEventsTimeline(this.state.events)}
      </div>
    );
  }

  render() {
    return (
      <div className="Timeline">
        {this.renderTimeline()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Timeline.js